<template>
  <div class="eu-display_inline">
    <div
      v-for="item in items"
      :key="item.name"
      class="eu-display_inline"
    >
      <router-link
        :to="{ name: item.routeName }"
        class="emd-link"
      >
        <app-breadcrumb-item :name="item.name" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppBreadcrumbLink',

  components: {
    AppBreadcrumbItem: () => import('./AppBreadcumbItem.vue')
  },

  props: {
    items: Array
  }
}
</script>
